<template>
  <div class="q-tool-bar">
    <fragment
      :key="`${schema.id}_${index}`"
      v-for="(item, index) in schema.items"
    >
      <component
        :is="item.xType"
        :schema="{ ...item, ...$options.filters._frm_data(schema.formData) }"
        :path="`${path}.items[${index}]`"
        @update:schema="
          (sval, stype, spath) => {
            $emit('update:schema', sval, stype, spath);
          }
        "
      >
      </component>
    </fragment>
  </div>
</template>

<script>
export default {
  name: "QToolBar",
  props: {
    schema: {
      type: Object,
      required: true,
    },
    path: {
      type: String,
      required: true,
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
